<div [style.width.%]="value"
    [style.background-color]="color"
class="kal-progress-bar__progress">
</div>
